<avi-toast
    [type]="notificationType"
    [actions]="actions"
    (onClose)="handleClose()"
>
    {{ l10nKeys.switchedToLabel | vtranslate: licensingTypeLabel }}
</avi-toast>
